import React, { useEffect } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import api from "services/api.service"

const BatchUpdatesOptions = ({
  scenario,
  scenarioId,
  selectedAlternativeList,
  selectedAlternatives,
  toggleListsModal,
  showSelectionAlert,
  removeFromList,
  copyProjects,
  moveProjects,
  deleteProjects,
  createLookback,
  deleteLookbacks,
  clearForecasts,
  toggleLock,
  toggleBatchUpdateModal,
}) => {
  const [showBatchDropdown, setShowBatchDropdown] = React.useState(false)
  const [scenarioActionItems, setScenarioActionItems] = React.useState([])

  useEffect(() => {
    loadActionItems()
  }, [])

  const loadActionItems = async () => {
    let scenarioActionItems = await api.getUserActionRights(
      scenarioId,
      "BatchUpdates"
    )
    setScenarioActionItems(scenarioActionItems)
    console.log("Scenario Action Items:", scenarioActionItems)
  }

  const hasActionItem = actionItemName => {
    return scenarioActionItems.some(item => item.actionItem === actionItemName)
  }

  if (scenarioActionItems.length === 0) {
    return null
  }

  return (
    <Dropdown
      direction="start"
      isOpen={showBatchDropdown}
      toggle={() => setShowBatchDropdown(!showBatchDropdown)}
    >
      <DropdownToggle tag="button" className="btn btn-outline-primary">
        Batch Updates <i className="mdi mdi-chevron-down" />
      </DropdownToggle>
      <DropdownMenu style={{ maxHeight: "500px", overflowX: "auto" }}>
        {(selectedAlternativeList == null ||
          selectedAlternativeList.listTypeID != 2) &&
          hasActionItem("AddToList") && (
            <>
              {(selectedAlternativeList == null ||
                selectedAlternativeList.listTypeID == 1) && (
                <DropdownItem
                  onClick={() => {
                    let selected = [...selectedAlternatives]
                    if (selected.length > 0) {
                      toggleListsModal()
                    } else {
                      showSelectionAlert()
                    }
                  }}
                >
                  Add {scenario && scenario.alternativeName.toLowerCase()}
                  (s) to list
                </DropdownItem>
              )}
              {selectedAlternativeList != null &&
                selectedAlternativeList.listTypeID == 1 && (
                  <DropdownItem
                    onClick={() => {
                      removeFromList()
                    }}
                  >
                    Remove {scenario && scenario.alternativeName.toLowerCase()}
                    (s) from list
                  </DropdownItem>
                )}
            </>
          )}

        {scenarioId != 0 && hasActionItem("CopyMove") && (
          <DropdownItem
            onClick={() => {
              copyProjects()
            }}
          >
            Copy {scenario && scenario.alternativeName.toLowerCase()}
            (s)
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("CopyMove") && (
          <DropdownItem
            onClick={() => {
              moveProjects()
            }}
          >
            Move {scenario && scenario.alternativeName.toLowerCase()}
            (s)
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("Delete") && (
          <DropdownItem
            onClick={() => {
              deleteProjects()
            }}
          >
            Delete {scenario && scenario.alternativeName.toLowerCase()}
            (s)
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("Lookbacks") && (
          <DropdownItem
            onClick={() => {
              createLookback()
            }}
          >
            Create lookback(s)
          </DropdownItem>
        )}
        {scenarioId != 0 && hasActionItem("Lookbacks") && (
          <DropdownItem
            onClick={() => {
              deleteLookbacks()
            }}
          >
            Delete lookback(s)
          </DropdownItem>
        )}
        {scenarioId != 0 && hasActionItem("Clear") && (
          <DropdownItem
            onClick={() => {
              clearForecasts()
            }}
          >
            Clear business case(s)
          </DropdownItem>
        )}
        {scenarioId != 0 && hasActionItem("Lock") && (
          <DropdownItem
            onClick={() => {
              toggleLock(true)
            }}
          >
            Lock business case(s)
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("Unlock") && (
          <DropdownItem
            onClick={() => {
              toggleLock(false)
            }}
          >
            Unlock business case(s)
          </DropdownItem>
        )}

        {scenarioId != 0 && hasActionItem("UpdateData") && (
          <DropdownItem
            onClick={() => {
              let selected = [...selectedAlternatives]
              if (selected.length > 0) {
                toggleBatchUpdateModal()
              } else {
                showSelectionAlert()
              }
            }}
          >
            Update Data
          </DropdownItem>
        )}
      </DropdownMenu>
    </Dropdown>
  )
}

export default BatchUpdatesOptions
